module.exports = __webpack_public_path__ + "static/media/herstory.d9c95e4c.PNG";